import styled, { css } from "styled-components";
export const FlashProductContainer = styled.a `
	display: flex;
	background: #fff;
    text-decoration: none;
    box-sizing: border-box;
	overflow: hidden;
	${(props) => {
    if (props.col === 1) {
        return css `
				border-radius: 0.375rem;
				padding: 0.625rem;
				.imgWrap {
					position: relative;
					width: 6.5rem;
					height: 6.5rem;
					flex: 0 0 auto;
					margin-bottom: 0.75rem;
				}
			`;
    }
    return css `
			width: 10.625rem;
			flex-direction: column;
			border-radius: 0.25rem;

			&:nth-child(2n) {
				margin-right: 0;
			}

			.imgWrap {
				position: relative;
				width: 10.625rem;
				height: 10.625rem;
				flex: 0 0 auto;
			}
		`;
}}
`;
export const FlashProductInfoBox = styled.section `
	${(props) => {
    if (props.col === 1) {
        return css `
				width: 100%;
				margin-left: 0.5rem;
				position: relative;
			`;
    }
    return css ``;
}}
`;
